export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MSAL_CLIENT_ID || '',
    authority: process.env.REACT_APP_MSAL_AUTHORITY || '',
    knownAuthorities: [process.env.REACT_APP_MSAL_AUTHORITY_DOMAIN || ''],
    redirectUri: process.env.REACT_APP_MSAL_INVITE_REDIRECT_URI || '',
    postLogoutRedirectUri: process.env.REACT_APP_MSAL_POST_LOGOUT_URI || '',
    navigateToLoginRequestUrl: true,
    scopes: ["openid", "profile", process.env.REACT_APP_MSAL_CLIENT_ID || '']
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  }
}
